<template>
  <div class="sky-page-peripheral-view">
    <div class="page-from-item wsp-display-flex wsp-padding-tb-12">
      <div class="page-from-value from-value">
        <el-button type="primary" @click="onSubmit">确定</el-button>
        <el-button @click="cancel">取消</el-button>
      </div>
    </div>
    <div class="page-from-item">
      <div class="page-from-label">外设选择：</div>
      <div class="page-from-value">
        <div class="page-function-toolbar">
          <el-button icon="el-icon-refresh" class="toolbar-left" @click="refushTable"></el-button>
          <el-input
            placeholder="请输入外设名称查询"
            class="toolbar-input"
            size="medium"
            v-model="searchKeyword"
            @blur="searchReq"
            @change="searchReq"
          >
            <span slot="suffix" class="el-input__suffix"
              ><span class="el-input__suffix-inner"> <i class="el-input__icon el-icon-search"></i></span>
            </span>
          </el-input>
          <div class="el-icon-warning wsp-padding-lr-6 wsp-line-height-24 bg-red">
            当前筛选对大小写敏感
          </div>
          <el-pagination
            class="toolbar-right"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            @prev-click="handelPrev"
            @next-click="handelNext"
            :page-sizes="[5, 10, 20, 50, 100]"
            layout="total,sizes,prev,sp,next"
            :current-page="page"
            :page-size="pageSize"
            :total="pageTotal"
          >
          </el-pagination>
          <el-table
            ref="table"
            height="600"
            :border="true"
            :data="listData"
            :show-header="true"
            :column-drag-sortable="false"
            class="sky-host-dist"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" :selectable="enableSelect"></el-table-column>
            <el-table-column label="外设名称" prop="name" show-overflow-tooltip />
            <el-table-column label="类型" prop="typeCN" show-overflow-tooltip />
            <el-table-column label="兼容情况" prop="hasCompatible" show-overflow-tooltip width="280"
              ><template slot-scope="scope">
                <div v-if="scope.row.compat.length > 0">
                  <span>
                    <el-tag :type="`${dictionary['compatibleStatus'][scope.row.compat[0].compatibleStatus]['type']}`">
                      {{ dictionary['compatibleStatus'][scope.row.compat[0].compatibleStatus]['label'] }}
                    </el-tag>
                    <span>【{{ scope.row.compat[0].productVersion }}】及以上</span>
                  </span>
                </div>
                <div v-else>
                  <el-tag type="danger">不兼容</el-tag>
                </div>
              </template></el-table-column
            >
            <el-table-column label="接口类型" prop="interfaceType" show-overflow-tooltip />
            <el-table-column label="制造商" prop="manufacturer" show-overflow-tooltip />
            <el-table-column label="硬件编码" prop="hardwareCode" show-overflow-tooltip />
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Table, TableColumn, Button, Pagination, RadioGroup, RadioButton, Input, Tag } from 'element-ui'

import dictionary from '../../../../../utils/dictionary'

import { getPeripheralList } from '@/api/peripheral'

// import lang from '@/lang'
export default {
  name: 'SkyFunctionTable',
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Button.name]: Button,
    [Pagination.name]: Pagination,
    [RadioGroup.name]: RadioGroup,
    [RadioButton.name]: RadioButton,
    [Input.name]: Input,
    [Tag.name]: Tag
  },
  props: {
    params: {
      type: Object,
      default: function() {
        return {}
      }
    },
    scenes: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  data: function() {
    return {
      selectItem: null,
      dictionary: dictionary,
      dialogVisible: false,
      shwoFunViewDetail: {},
      listData: [],
      selectable: null,
      selectFuntion: [],
      searchKeyword: '',
      pageTotal: 0,
      pageSize: 20,
      reqParmas: {
        exactMatchArr: [],
        matchArr: [],
        page: this.page - 1,
        limit: 20
      },
      page: 1
    }
  },
  created() {},
  mounted() {
    this.getData()
  },
  methods: {
    refushTable() {
      this.getData()
    },
    getData() {
      this.reqParmas.page = this.page - 1
      this.reqParmas.limit = this.pageSize
      getPeripheralList(this.reqParmas).then(res => {
        this.listData = res.data.content.itemArr
        this.pageTotal = res.data.content.total
      })
    },
    searchReq() {
      if (this.searchKeyword !== '') {
        //
        const exists = this.reqParmas.matchArr.some(obj => obj.fieldNameArr)
        if (exists) {
          for (const iterator of this.reqParmas.matchArr) {
            if (iterator.fieldNameArr) {
              iterator.value = this.searchKeyword
            }
          }
        } else {
          this.reqParmas.matchArr.push({
            type: 'FUZZY',
            fieldNameArr: ['name'],
            value: this.searchKeyword,
            matchRule: 'FULL'
          })
        }
      } else {
        for (let index = 0; index < this.reqParmas.matchArr.length; index++) {
          const element = this.reqParmas.matchArr[index]
          if (element.fieldNameArr) {
            this.reqParmas.matchArr.splice(index, 1)
          }
        }
      }

      this.getData()
    },
    onSubmit() {
      if (this.selectItem.length > 0) {
        this.$emit('addSelect', { select: this.selectItem, type: 'Peripheral' })
      }
    },
    handleSelectionChange(val) {
      this.selectItem = val
    },
    handleCloseDrawer() {
      this.shwoFunViewDetail = {}
      this.dialogVisible = false
    },
    cancel() {
      this.$parent.$parent.$parent.closeDrawer()
    },
    enableSelect(row, index) {
      if (row.compat.length > 0) {
        if (row.compat[0].compatibleStatus === 'NOT_SUPPORTED') {
          return false
        }
        return true
      }
      return true
    },
    // size 变更 每页条数
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    //
    handleCurrentChange() {},
    handelPrev() {
      this.page--
      this.getData()
    },
    handelNext() {
      this.page++
      this.getData()
    }
  }
}
</script>

<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(page-peripheral-view) {
  height: 100%;
  .page-from-item {
    padding: 0 6px;
    line-height: 28px;
    .page-from-item-label {
      font-size: 14px;
      font-weight: 600;
    }
    .page-from-label {
      width: 8%;
    }
    .from-value {
      padding-left: 12px;
    }
    .page-from-item-value {
    }
  }
  .page-function-toolbar {
    .toolbar-input {
      width: 39%;
    }
    .toolbar-left {
      float: left;
    }
    .toolbar-right {
      float: right;
    }
  }
}
</style>
